const firebaseConfig = {
  apiKey: "AIzaSyCrt2H76fpb5U0aoXbz7LtHQmeryvGdR-k",
  authDomain: "quiklearn-k12-prod.firebaseapp.com",
  projectId: "quiklearn-k12-prod",
  storageBucket: "quiklearn-k12-prod.firebasestorage.app",
  messagingSenderId: "1079147220958",
  appId: "1:1079147220958:web:cbe6afba4c2d0cbe10174f",
  measurementId: "G-56XHG5R81T"
};

export default firebaseConfig;
